<template>
  <b-navbar toggleable="lg" type="light" variant="faded">
    <router-link :to="{ name: 'Home' }" tag="span" class="cursor-pointer sg-logo">
      <b-img
        :src="require('@/assets/img/logo-inline.png')"
        fluid
      />
    </router-link>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <!-- no session -->
    <b-collapse id="nav-collapse" class="ml-3" is-nav v-if="!user">
      <!-- left -->
      <b-navbar-nav class="ml-3 pt-3">
        <b-nav-item class="p-0" style="font-size: 20px; font-weight: 600;" :to="{ name: 'AboutUs'}">
          About Us
        </b-nav-item>

        <b-nav-item-dropdown class="p-0" style="font-size: 20px; font-weight: 600;">
          <template slot="button-content">Services</template>

          <b-dropdown-item v-for="(service, i) in services" :key="i">
            <router-link class="ddl-item text-dark btn" :to="{ name: service}">
              {{ service }}
            </router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown class="p-0" style="font-size: 20px; font-weight: 600;">
          <template slot="button-content">How To</template>

          <b-dropdown-item>
            <router-link tag="span" class="ddl-item text-dark btn" :to="{ name: 'HowToBook'}">
              How to Book
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link tag="span" class="ddl-item text-dark btn" :to="{ name: 'HowItWorks'}">
              How it Works
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link tag="span" class="ddl-item text-dark btn" :to="{ name: 'BecomeAGuider'}">
              Become a Guider
            </router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!-- right -->
      <b-navbar-nav class="ml-auto pt-3">
        <!-- <b-nav-item class="pt-1 text-dark btn" style="font-size: 20px; font-weight: 600;">
          <font-awesome-icon icon="globe" /> EN | ID
        </b-nav-item> -->

        <b-nav-item class="pt-1 text-dark btn" style="font-size: 20px; font-weight: 600;" :to="{ name: 'Login'}">
          LOGIN
        </b-nav-item>

        <b-nav-item :to="{ name: 'Register'}">
          <div class="btn btn-primary">
            JOIN
          </div>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <!-- has session -->
    <b-collapse id="nav-collapse" is-nav v-if="user">
      <b-navbar-nav class="ml-auto" :key="keyComponent">
        <div v-if="pending_order" class="center-base all p-3 btn" @click="changeRoute('Order')">
          <font-awesome-icon
            icon="luggage-cart"
            style="font-size: 20px; color: #727272;"
            id="tooltip-order"
          />
          <b-tooltip target="tooltip-order" show variant="success">
            <span style="font-size: 18px;">You have unfinished order!</span>
          </b-tooltip>
        </div>

        <div v-if="pending_payment" class="center-base all p-3 btn" @click="changeRoute('Pay/Now')">
          <font-awesome-icon
            icon="credit-card"
            style="font-size: 20px; color: #727272;"
            id="tooltip-payment"
          />
          <b-tooltip target="tooltip-payment" show variant="success">
            <span style="font-size: 18px;">We waiting your payment!</span>
          </b-tooltip>
        </div>

        <b-nav-item>
          <router-link
          tag="span"
          class="p-0 text-dark btn"
          :to="{ name: route_to}"
          style="color: #233c7c;"
          >
            <b-img
              :src="user_picture"
              style="width: 3em; height: 3em; border-radius: 50%; object-fit: cover;"
            />
            {{ user_name }}
          </router-link>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
// external dependencies
import VueJwtDecode from 'vue-jwt-decode'

// custom component

// api call
import AuthenticationAPI from '@/api/AuthenticationAPI'
import UserFileAPI from '@/api/UserFileAPI'

export default {
  name: 'Header',
  data () {
    return {
      user: this.user,
      user_picture: '',

      services: ['StarX', 'StarVan', 'StarGroup', 'StarRoad', 'StarTrip', 'StarPick'],

      route_to: '',
      pending_order: false,
      pending_payment: false,

      keyComponent: 0
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
      this.user_name = decode.first_name
    } else {
      this.user = null
      this.user_name = null
    }
  },
  mounted: function () {
    this.getUserPicture()
    this.checkPending()

    if (this.user) {
      this.route_to = 'MyAccount'
    }

    // munculin tooltip
    setTimeout(() => {
      this.$root.$emit('bv::hide::tooltip', 'tooltip-order')
      this.$root.$emit('bv::hide::tooltip', 'tooltip-payment')
    }, 3000)
  },
  onIdle: async function () {
    if (this.$session.exists()) {
      try {
        await AuthenticationAPI.logoutTracker(this.user)

        this.$session.destroy()

        this.$cookies.remove(`user_session`)
        this.$cookies.remove(`order_data`)
        this.$cookies.remove(`payment_data`)

        this.$router.push({ name: 'Login' })
        this.$router.go()
      } catch (err) {
        console.log(err)
      }
    }
  },
  watch: {
    $route () {
      this.checkPending()
    }
  },
  methods: {
    // PREREQUISITES
    changeRoute: function (newRoute) {
      if (this.$router.currentRoute.name !== newRoute) {
        this.$router.push(newRoute)
      }
    },
    checkPending: function () {
      if (this.$cookies.get('order_data') && this.$router.currentRoute.name !== 'Order') {
        this.pending_order = true
      } else {
        this.pending_order = false
      }

      if (this.$cookies.get('payment_data') && this.$router.currentRoute.name !== 'Pay_Now') {
        this.pending_payment = true
      } else {
        this.pending_payment = false
      }
    },
    // END PREREQUISITES

    // HTTP REQUEST
    getUserPicture: async function () {
      if (this.user) {
        let response = await UserFileAPI.getFile({ _id: this.user.picture })

        if (response.data.record) {
          this.user_picture = this.globalProp.vs + 'u/' + this.user._id + '/user_picture/' + response.data.record.file_name + '.' + response.data.record.file_type
        } else {
          this.user_picture = require('@/assets/img/blank-profile.png')
        }
      }
    },
    logout: async function () {
      try {
        await AuthenticationAPI.logoutTracker(this.user)

        this.$session.destroy()

        this.$cookies.remove(`user_session`)
        this.$cookies.remove(`order_data`)
        this.$cookies.remove(`payment_data`)

        this.$router.push({ name: 'Login' })
        this.$router.go()
      } catch (err) {
        console.log(err)
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-logo {
  padding: 5px;
}
@media screen and (max-width: 767px) {
  .sg-logo {
    max-width: 9em;
  }
}
@media screen and (min-width: 768px) {
  .sg-logo {
    max-width: 14em;
  }
}

.btn.btn-primary {
  font-weight: 600;
  font-size: 20px;

  border-color: #233c7c;
  background-color: #233c7c;
}
.btn:hover {
  cursor: pointer;
}

.navbar-nav,
.nav-link,
.dropdown-menu > li {
  text-align: center;
}

/* dropdown item for service & how to */
.ddl-item {
  padding: 0.25rem;

  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  display: block;
}
/* END dropdown item for service & how to */
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue